/**
 * 微信管理
 */

import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'
import { jsonToUrlParam } from '@/utils'
const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 获取precode
export const getPreAuthCode = (data?: any) =>
  request.post('/admin/wx/public/preAuthCode', data, jsonHeaderConfig)
// 获取授权账号信息
export const getAuthorizerInfo = (data?: any) =>
  request.post(`/admin/wx/notify/getAuthorizerInfo?tenantId=${data}`, null, jsonHeaderConfig)
// 通过授权后code保存授权信息
export const saveAuthorizerInfo = (data?: any) =>
  request.post(
    `/admin/wx/public/saveAuthorizationInfo?${jsonToUrlParam(data)}`,
    null,
    jsonHeaderConfig
  )
// 解绑
export const unbindAuthorizerInfo = (data?: any) =>
  request.post(`/admin/wx/notify/deAuthorization?tenantId=${data}`, null, jsonHeaderConfig)
